import {createContext, useContext} from 'react';

export const initialValues = {
  forVisualizer: "",
  forWizardId: "",
};

export const pricingAction = "CHANGE_PRICING_CONTEXT";

const PricingContext = createContext({});

export const usePricingContext = () => {
  return useContext(PricingContext);
}

export const pricingContextReducer = (state = initialValues, action) => {
  switch (action.type) {
    case pricingAction:
      return {...state, ...action.payload};
    default:
      return state
  }
}

export default PricingContext;
